export default {
  common: {
    loading: '加载中...',
    networkError: '网络异常，请检查网络后重试或联系IT5000',
    minutes: '分钟',
    hour: '小时',
    readyToStart: '未开始',
    ing: '进行中',
    finishedAuto: '自动结束',
    finishedByPresenter: '主持人结束视频会议',
    plsOpenInBrowser: '请在浏览器中打开',
    plsOpenInSafari: '请在Safari中打开',
    ok: '好的',
    stillUse: '依然使用',
    or: '或'
  },
  meeting: {
    detail: '会议详情',
    chinaRecommend: '美的员工 推荐',
    outsideRecommend: '合作伙伴/访客 推荐',
    openInMission: '美信入会',
    openInMideaMeeting: 'Midea Meeting客户端入会',
    openInWXMeeting: '腾讯会议客户端入会',
    openInWXApplet: '小程序入会',
    notStart: '会议尚未开始',
    hasFinished: '会议已结束',
    hasCanceled: '会议已取消',
    openMission: '该页面会唤起美信',
    openTXMeeting: '该页面会唤起腾讯会议',
    clickDownloadMission: '若无法正常跳转或入会，请先点击【下载美信】按钮',
    installedMission: '若您已安装了美信，请',
    clickHere: '点击此处',
    openMissionTips: '如果浏览器对话框弹出，请点击【打开美信】按钮',
    clickDownloadTXMeeting: '若无法正常跳转请先点击【立即下载】按钮',
    needTXMeeting: '使用其他方式加入会议',
    installedTXMeeting: '若您已经安装了腾讯会议, 请 ',
    openTXMeetingTips: '若浏览器对话框弹出, 请点击【打开腾讯会议】按钮',
    donwloadMissionImed: '下载美信',
    donwloadTXMeetingImed: '立即下载',
    downloadMideaMeeting: 'Midea Meeting客户端下载',
    openMideaMeeting: '该页面将会唤起Midea Meeting',
    clickDownload: '若无法正常跳转请先点击【立即下载】按钮',
    installedMideaMeeting: '若您已安装了美的会议，请',
    browserDialogOpened: '如果浏览器对话框弹出',
    clickOpenMideaMeetingBtn: '请点击【打开Midea Meeting】按钮',
    donwloadImed: '立即下载',
    dontWantToDownload: '实在不想下载？使用',
    joinMeetingInBrowser: '浏览器入会',
    cancelMeetingInfo: '以下会议信息已失效',
    otherToMeeting: '其他参会方式',
    browserMeetingTips: '仅支持Chrome/Firefox/Safari，会议质量可能欠佳',
    readingGuideline: '查看详细操作指引',
    downloadMX: '美信下载',
    downloadTXMeeting: '腾讯会议客户端下载',
    back: '返回会议详情',
    isNotChinesePhone: '如果您使用非中国大陆地区手机号码，请点击前往',
    downloadVooV: '下载VooV Meeting',
    scan: '长按保存并使用微信扫码',
    joinInMeeting: '加入会议',
  }
}
